// TadsCPMHost.tsx
import React, { useEffect } from 'react';
import { TadsWidget, renderTadsWidget } from 'react-tads-widget';

import { TADS_CPM_EVENT_SHOW, resolveTadsCpm } from './TadsCPMBoostProvider';
const host = window.location.hostname;
const isSpecialHost = host === '3afhg7uh4r.a.trbcdn.net';

const WIDGET_ID = isSpecialHost ? '9508' : '633';

export const TadsCPMHost: React.FC = () => {
  useEffect(() => {
    const onShow = () => {
      renderTadsWidget({ id: WIDGET_ID, type: 'fullscreen' });
    };

    window.addEventListener(TADS_CPM_EVENT_SHOW, onShow);
    return () => window.removeEventListener(TADS_CPM_EVENT_SHOW, onShow);
  }, []);

  return (
    <TadsWidget
      id={WIDGET_ID}
      type="fullscreen"
      debug={false}
      onShowReward={() => resolveTadsCpm('success')}
      onClickReward={() => resolveTadsCpm('success')}
      onAdsNotFound={() => resolveTadsCpm('ads_not_found')}
    />
  );
};
